import moment from 'moment';

// const LOCAL_SERVER_URL = "http://172.16.1.88:4023";
// const LOCAL_SERVER_URL =`${localStorage.getItem("serverName")}` //"http://192.168.20.145:4023";
const LOCAL_IP = "http://localhost:4000"




// export async function _SERVER_URL() {
//     // Número máximo de intentos
//     const maxAttempts = 3;
//     let attempts = 0;
    
//     while (attempts < maxAttempts) {
//         try {
//             const controller = new AbortController();
//             const signal = controller.signal;
//             const timeout = setTimeout(() => {
//                 controller.abort();
//             }, 5000);
    
//             const URL_EMPRESA = LOCAL_SERVER_URL; // Modifica esta línea con la URL que deseas usar
//             const ENDPOINT_TEST = 'check_server_status';
    
//             //console.log(URL_EMPRESA);
    
//             const publicResponse = await fetch(`${URL_EMPRESA}/${ENDPOINT_TEST}`, { method: 'HEAD', signal, keepalive: false });
//             clearTimeout(timeout);
    
//             //console.log((publicResponse && publicResponse.ok) ? 'IP Pública' : 'IP Local');
    
//             return (publicResponse && publicResponse.ok) ? `${URL_EMPRESA}` : LOCAL_SERVER_URL;
    
//         } catch (error) {
//             console.error('Error al intentar conectarse:', error);
//             attempts++;
//             if (attempts < maxAttempts) {
//                 //console.log(`Reintentando en 2 segundos (intentos restantes: ${maxAttempts - attempts})`);
//                 await new Promise(resolve => setTimeout(resolve, 2000));
//             } else {
//                 //console.log('Se alcanzó el número máximo de intentos. No se pudo establecer conexión.');
//                 return "Error en conexión";
//             }
//         }
//     }
    
// }

export async function GetCenters( service , servidor) { 
    console.log("Entro a rutina para solicitud de GetCenters", service);
    try {
        let username = localStorage.getItem("username");

        const endpoint = `/${service.toLowerCase()}/get_centers`;
        const fullUrl = `${servidor}${endpoint}`;
        console.log('Respuesta fullUrl', fullUrl);

        const response = await fetch(fullUrl, {
            method: 'POST',
            credentials: 'include',         // ← aquí también
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({username: username}),
            keepalive: false,
        });

        const data = await response.json();
        console.log("Respuesta del servidor:", data);

        // Manejar la sesión expirada
        if (data.mensaje === "El usuario no corresponde a esta sesion") {
            console.log("La sesión ha expirado");
            return ['session_expired', null];  // Retorna el estado de sesión expirada
        }

        // Manejar errores HTTP
        if (!response.ok) {
            throw new Error(data.mensaje || "Error al obtener los centros");
        }

        return [true, data.IDs];  // Retorna los centros si todo está bien

    } catch (error) {
        console.error("Hubo un error al obtener los centros:", error.message || error);
        return [false, null];  // Devuelve null como valor, no como cadena
    }
}

// ? FUNCIONES USUARIOS

//METODO CREACION DE USUARIO
// export async function CrearUsuario(usuarios, setAlertMessage, setAlertSeverity, translate, servidor, token) {
//     try {
//         // Obtener la URL del servidor
//         const SERVER_URL = await servidor;
//         //console.log('SERVER_URL', SERVER_URL)

//         // Realizar la solicitud POST al servidor
//         const response = await fetch(`${SERVER_URL}/crear_usuario`, {
//             method: 'POST',
//             headers: {
//                 'Content-Type': 'application/json',
//                 'Authorization': `Bearer ${token}`,
//             },
//             body: JSON.stringify(usuarios)
//         });

//         if (response && response.ok) {
//             // setAlertMessage('Usuario creado con éxito!');
//             setAlertMessage(translate('create_success_message'));
//             setAlertSeverity('success');
//           }

//         // Verificar si la respuesta es exitosa
//         if (!response.ok) {
//             // front
//             let errorMessage;
//             if (response.status === 409) {
//               errorMessage = translate('create_errorExiste_message');
//             } else {
//               errorMessage = translate('create_error1_message');
//             }
//             setAlertMessage(errorMessage);
//             setAlertSeverity('error');
//             // Si la respuesta no es exitosa, lanzar un error con el mensaje del servidor
//             const errorData = await response.json();
//             throw new Error(errorData.mensaje || translate('create_error2_message'));
//         }

//         // Si la respuesta es exitosa, devolver los datos recibidos del servidor
//         return await response.json();
//     } catch (error) {
//         // Capturar y manejar cualquier error que ocurra durante la solicitud
//         console.error('Hubo un error al crear nuevo usuario:', error);
//         //console.log( {error});
//         setAlertMessage(translate('create_error3_message'));
//         setAlertSeverity('error');
//         // setAlertMessage('Hubo un error al crear nuevo usuario:', error)

//         throw error;
//     }
// }
// MÉTODO CREACIÓN DE USUARIO (soporta respuestas individuales y batch)
export async function CrearUsuario(
  usuarios,                  // objeto o array de objetos usuario
  setAlertMessage,
  setAlertSeverity,
  translate,
  servidor,
  token
) {
  try {
    const SERVER_URL = await servidor;
    console.log( 'URL SERVIDOR :',`${SERVER_URL}/crear_usuario`)
    console.log( 'usuario a guardar :',usuarios)
    
    const response = await fetch(`${SERVER_URL}/crear_usuario`, {
      method: 'POST',
      credentials:'include',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
      body: JSON.stringify(usuarios),
    });
    console.log( 'DENTRO DEL SERVIDOR :',`${SERVER_URL}/crear_usuario`)

    // Obtengo siempre el JSON (puede ser { resultados: [...] } o un objeto único)
    const data = await response.json();
    console.log('response',response)
    console.log('data',data)

    // Helper para traducir errores según código
    const getErrorKey = (status) => {
      switch (status) {
        case 400: return 'create_error1_message';      // genérico campos inválidos
        case 401: return 'create_errorAuth_message';   // permisos no autorizados
        case 403: return 'create_errorPermiso_message';// JWT sin permisos
        case 409: return 'create_errorExiste_message'; // usuario ya existe
        case 422: return 'create_errorEmail_message';  // validación de correo
        case 500: return 'create_error2_message';      // error interno
        default:  return 'create_error1_message';
      }
    };

    // Si el servidor envía un array de resultados
    if (Array.isArray(data.resultados)) {
      const successMsgs = [];
      const errorMsgs = [];

      data.resultados.forEach(({ usuario, estado, resultado }) => {
        const msgServidor = resultado?.mensaje || '';
        if (estado === 201) {
          successMsgs.push(`${translate('create_success_message')}: ${msgServidor}`);
        } else {
          // traduzco según estado o muestro mensaje tal cual
          const key = getErrorKey(estado);
          const texto = (key === 'create_error1_message')
            ? msgServidor
            : translate(key);
          errorMsgs.push(`Usuario "${usuario}": ${texto}`);
        }
      });

      // Primero muestro éxitos, luego errores (si los hay)
      if (successMsgs.length) {
        setAlertMessage(successMsgs.join('  '));
        setAlertSeverity('success');
      }
      if (errorMsgs.length) {
        setAlertMessage(errorMsgs.join('  '));
        setAlertSeverity('error');
      }

      return data; // devuelvo todo el objeto para quien lo necesite
    }

    // Si es respuesta única (no array)
    if (response.ok) {
      setAlertMessage(translate('create_success_message'));
      setAlertSeverity('success');
      return data;
    } else {
      // determino clave de traducción y mensaje
      const status = response.status;
      const key = getErrorKey(status);
      const serverMsg = data.mensaje;
      const text = (key === 'create_error1_message')
        ? serverMsg
        : translate(key);

      setAlertMessage(text);
      setAlertSeverity('error');

      throw new Error(serverMsg || translate('create_error2_message'));
    }
  } catch (error) {
    console.error('Error en CrearUsuario:', error);
    setAlertMessage(translate('create_error3_message'));
    setAlertSeverity('error');
    throw error;
  }
}

//METODO PARA SOLICITAR LOS USUSRIOS QUE SE PUEDEN EDITAR 
export async function ObtenerUsuarios(servidor) {
    // //console.log("Obteniendo usuarios que se pueden editar");

    let SERVER_URL = await servidor;
    // let access_token =  localStorage.getItem("access_token");


    console.log('SERVER_URL',`${SERVER_URL}/ediciones_usuario/`)

    try {
        const response = await fetch(`${SERVER_URL}/ediciones_usuario`, {
            method: 'GET',
            credentials: 'include',         // ← aquí también
            headers: {
                'Content-Type': 'application/json',
                // 'Authorization' : `Bearer ${access_token}`
            },
            keepalive: false  // Asegura cerrar la conexión después de que se haya completado la solicitud
        });

        const data = await response.json();

        // console.log("Usuarios que se pueden editar:", data);

        // Si la respuesta no es exitosa, lanza un error
        if (!response.ok) {
            throw new Error(data.mensaje || "Error al obtener usuarios para editar");
        }

        return data;

    } catch (error) {
        console.error("Hubo un error al obtener usuarios para editar:", error);
        throw error;
    }
  };

// Función para editar usuario
export async function EditarUsuario(user,  servidor, token) {
  console.log('edicion')
    console.log('user',user)
    try {
        // Obtener la URL del servidor
        const SERVER_URL = await servidor;
        
        // Realizar la solicitud POST al servidor para editar el usuario
        const response = await fetch(`${SERVER_URL}/editar_usuarios`, {
            method: 'POST',
            credentials:'include',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token}`,
            },
            body: JSON.stringify(user)
        });

        // Verificar si la respuesta es exitosa
        if (response.ok) {

            // Si la respuesta es exitosa, devolver los datos recibidos del servidor
            return await response.json();
        } else {
            // Si la respuesta no es exitosa, lanzar un error con el mensaje del servidor
            const errorData = await response.json();
            throw new Error(errorData.mensaje || 'Error al editar usuario');
        }
    } catch (error) {
        // Capturar y manejar cualquier error que ocurra durante la solicitud
        console.error('Hubo un error al editar usuario:', error);
        throw error;
    }
}


//METODO PARA ELIMINAR USUARIO
export async function EliminarUsuario(clientName, usuario, servidor) {
    // ClienteName nombre del usuario que esta elimiando
    // usuario es el que se esta eliminando
    let SERVER_URL = await servidor;
    const username =  usuario.username

    try {
      // console.log('RUTA', `${SERVER_URL}/delete_user/${clientName}/${username}`)
        const response = await fetch(`${SERVER_URL}/delete_user/${clientName}/${username}`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json'
            },

            keepalive: false  // Asegura cerrar la conexión después de que se haya completado la solicitud
        });

        const data = await response.json();

        //console.log(data)

        // Si la respuesta no es exitosa, lanza un error
        if (!response.ok) {
            throw new Error(data.mensaje || "Error intentando eliminar  usuario");
        }

        return data;


    } catch (error) {
        console.error("Hubo un error al eliminar  usuario:", error);
        throw error;
    }
}


//METODO PARA CREAR CENTRO
// export async function CrearCentro(center, setAlertMessage, setAlertSeverity,translate, servidor, token) {
//     // clientName => usuario que esta creando
//     console.log('center',center)
//     console.log('servidor',servidor)
//     console.log('token',token)
//     try {
//         // Obtener la URL del servidor
//         const SERVER_URL = await servidor;
//         console.log('SERVER_URL', SERVER_URL)

//         // Realizar la solicitud POST al servidor
//         const response = await fetch(`${SERVER_URL}/crear_centro`, {
//             method: 'POST',
//             headers: {
//                 'Content-Type': 'application/json',
//                 'Authorization' : `Bearer ${token}`

//             },
//             body: JSON.stringify(center)
//         });
//         if (response && response.ok) {
//             // setAlertMessage('Usuario creado con éxito!');
//             setAlertMessage(translate('create_center_success_message'));
//             setAlertSeverity('success');
//           }

//         // Verificar si la respuesta es exitosa
//         if (!response.ok) {
//             // front
//             let errorMessage;
//             if (response.status === 409) {
//               errorMessage = translate('create_center_errorExiste_message');
//             } else {
//               errorMessage = translate('create_center_error1_message');
//             }
//             setAlertMessage(errorMessage);
//             setAlertSeverity('error');
//             // Si la respuesta no es exitosa, lanzar un error con el mensaje del servidor
//             const errorData = await response.json();
//             throw new Error(errorData.mensaje || translate('create_center_error2_message'));
//         }

//         // Si la respuesta es exitosa, devolver los datos recibidos del servidor
//         return await response.json();
//     } catch (error) {
//         // Capturar y manejar cualquier error que ocurra durante la solicitud
//         console.error('Hubo un error al crear nuevo centro:', error);
//         //console.log( {error});
//         setAlertMessage(translate('create_center_error3_message'));
//         setAlertSeverity('error');
//         // setAlertMessage('Hubo un error al crear nuevo usuario:', error)

//         throw error;
//     }
// }

export async function CrearCentro(
  center,                  // objeto o array de objetos usuario
  setAlertMessage,
  setAlertSeverity,
  translate,
  servidor,
  token
) {
  try {
    const SERVER_URL = await servidor;
    console.log( 'URL SERVIDOR :',`${SERVER_URL}/crear_centro`)
    console.log( 'center :',center)
    
    const response = await fetch(`${SERVER_URL}/crear_centro`, {
      method: 'POST',
      credentials:'include',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
      body: JSON.stringify(center),
    });
    console.log( 'DENTRO DEL SERVIDOR :',`${SERVER_URL}/crear_centro`)

    // Obtengo siempre el JSON (puede ser { resultados: [...] } o un objeto único)
    const data = await response.json();
    console.log('response',response)
    console.log('data',data)

    // Helper para traducir errores según código
    const getErrorKey = (status) => {
      switch (status) {
        case 400: return 'create_error1_message';      // genérico campos inválidos
        case 401: return 'create_errorAuth_message';   // permisos no autorizados
        case 403: return 'create_errorPermiso_message';// JWT sin permisos
        case 409: return 'centros_auto_conflict'; // automático: usar Detectados/Editar
        case 422: return 'create_errorEmail_message';  // validación de correo
        case 500: return 'create_error2_message';      // error interno
        default:  return 'create_error1_message';
      }
    };

    // Si el servidor envía un array de resultados
    if (Array.isArray(data.resultados)) {
      const successMsgs = [];
      const errorMsgs = [];

      data.resultados.forEach(({ centro, estado, resultado }) => {
        const msgServidor = resultado?.mensaje || '';
        if (estado === 201) {
          successMsgs.push(`${translate('create_center_success_message')}: ${msgServidor}`);
        } else {
          // traduzco según estado o muestro mensaje tal cual
          const key = getErrorKey(estado);
          const texto = (key === 'create_error1_message')
            ? msgServidor
            : translate(key);
          errorMsgs.push(`Centro "${centro}": ${texto}`);
        }
      });

      // Primero muestro éxitos, luego errores (si los hay)
      if (successMsgs.length) {
        setAlertMessage(successMsgs.join('  '));
        setAlertSeverity('success');
      }
      if (errorMsgs.length) {
        setAlertMessage(errorMsgs.join('  '));
        setAlertSeverity('error');
      }

      return data; // devuelvo todo el objeto para quien lo necesite
    }

    // Si es respuesta única (no array)
    if (response.ok) {
      setAlertMessage(translate('create_center_success_message'));
      setAlertSeverity('success');
      return data;
    } else {
      // determino clave de traducción y mensaje
      const status = response.status;
      const key = getErrorKey(status);
      const serverMsg = data.mensaje;
      const text = (key === 'create_error1_message')
        ? serverMsg
        : translate(key);

      setAlertMessage(text);
      setAlertSeverity('error');

      const error = new Error(serverMsg || translate('create_error2_message'));
      error.displayed = true;
      throw error;
    }
  } catch (error) {
    console.error('Error en CrearCentro:', error);
    if (!error.displayed) setAlertMessage(translate('create_error3_message'));
    setAlertSeverity('error');
    throw error;
  }
}

//METODO PARA SOLICITAR LOS USUSRIOS QUE SE PUEDEN EDITAR 
export async function ObtenerCentros(servidor, token) {
    // //console.log("Obteniendo usuarios que se pueden editar");

    let SERVER_URL = await servidor;
    // let access_token =  localStorage.getItem("access_token");


    try {
        const response = await fetch(`${SERVER_URL}/obtener_centros`, {
            method: 'GET',
            credentials: 'include',         // ← aquí también
            headers: {
                'Content-Type': 'application/json',
                'Authorization' : `Bearer ${token}`
            },
            keepalive: false  // Asegura cerrar la conexión después de que se haya completado la solicitud
        });

        const data = await response.json();

        // //console.log("Usuarios que se pueden editar:", data);

        // Si la respuesta no es exitosa, lanza un error
        if (!response.ok) {
            throw new Error(data.mensaje || "Error al obtener centros para editar");
        }

        return data;

    } catch (error) {
        console.error("Hubo un error al obtener centros para editar:", error);
        throw error;
    }
  };


export async function EliminarCentro(centerId, servidor, token) {
    // ClienteName nombre del usuario que esta elimiando
    // usuario es el que se esta eliminando
    //console.log("eliminando  centro")

    let SERVER_URL = await servidor;


    try {
        const response = await fetch(`${SERVER_URL}/eliminar_centro/${centerId}`, {
            method: 'POST',
            credentials: 'include',         // ← aquí también
            headers: {
                'Content-Type': 'application/json',
                'Authorization' : `Bearer ${token}`
            },

            keepalive: false  // Asegura cerrar la conexión después de que se haya completado la solicitud
        });

        const data = await response.json();

        //console.log(data)

        // Si la respuesta no es exitosa, lanza un error
        if (!response.ok) {
            throw new Error(data.mensaje || "Error intentando eliminar  centro");
        }

        return data;


    } catch (error) {
        console.error("Hubo un error al eliminar  centro:", error);
        throw error;
    }
}


// export async function EditarCentro(center, setAlertMessage, setAlertSeverity,translate, centroSeleccionado, servidor) {
//     // clientName => usuario que esta creando
//     //console.log('center edit',center)
//     try {
//         // Obtener la URL del servidor
//         const SERVER_URL = await servidor;
//         //console.log('SERVER_URL', SERVER_URL)

//         // Realizar la solicitud POST al servidor
//         const response = await fetch(`${SERVER_URL}/editar_centro/${centroSeleccionado}`, {
//             method: 'POST',
//             headers: {
//                 'Content-Type': 'application/json'
//             },
//             body: JSON.stringify(center)
//         });
// //console.log('response',response)
//         if (response && response.ok) {
//             // setAlertMessage('Usuario creado con éxito!');
//             setAlertMessage(translate('edit_center_success_message'));
//             setAlertSeverity('success');
//           }

//         // Si la respuesta es exitosa, devolver los datos recibidos del servidor
//         return await response.json();
//     } catch (error) {
//         // Capturar y manejar cualquier error que ocurra durante la solicitud
//         console.error('Hubo un error al editar el centro:', error);
//         //console.log( {error});
//         setAlertMessage(translate('edit_center_error3_message'));
//         setAlertSeverity('error');
//         // setAlertMessage('Hubo un error al crear nuevo usuario:', error)

//         throw error;
//     }
// }
export async function EditarCentro(
  center,                  // objeto o array de objetos usuario
  setAlertMessage,
  setAlertSeverity,
  translate,
  centroSeleccionado,
  servidor,
  token
) {
  try {
    const SERVER_URL = await servidor;
    console.log( 'URL SERVIDOR :',`${SERVER_URL}/editar_centro/${centroSeleccionado}`)
    console.log( 'center :',center)
    
    const response = await fetch(`${SERVER_URL}/editar_centro/${centroSeleccionado}`, {
      method: 'POST',
      credentials:'include',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
      body: JSON.stringify(center),
    });
    console.log( 'DENTRO DEL SERVIDOR :',`${SERVER_URL}/editar_centro/${centroSeleccionado}`)

    // Obtengo siempre el JSON (puede ser { resultados: [...] } o un objeto único)
    const data = await response.json();
    console.log('response',response)
    console.log('data',data)

    // Helper para traducir errores según código
    const getErrorKey = (status) => {
      switch (status) {
        case 400: return 'create_error1_message';      // genérico campos inválidos
        case 401: return 'create_errorAuth_message';   // permisos no autorizados
        case 403: return 'create_errorPermiso_message';// JWT sin permisos
        case 409: return 'create_errorExiste_message'; // usuario ya existe
        case 422: return 'create_errorEmail_message';  // validación de correo
        case 500: return 'create_error2_message';      // error interno
        default:  return 'create_error1_message';
      }
    };

    // Si el servidor envía un array de resultados
    if (Array.isArray(data.resultados)) {
      const successMsgs = [];
      const errorMsgs = [];

      data.resultados.forEach(({ centro, estado, resultado }) => {
        const msgServidor = resultado?.mensaje || '';
        if (estado === 201) {
          successMsgs.push(`${translate('create_center_success_message')}: ${msgServidor}`);
        } else {
          // traduzco según estado o muestro mensaje tal cual
          const key = getErrorKey(estado);
          const texto = (key === 'create_error1_message')
            ? msgServidor
            : translate(key);
          errorMsgs.push(`Centro "${centro}": ${texto}`);
        }
      });

      // Primero muestro éxitos, luego errores (si los hay)
      if (successMsgs.length) {
        setAlertMessage(successMsgs.join('  '));
        setAlertSeverity('success');
      }
      if (errorMsgs.length) {
        setAlertMessage(errorMsgs.join('  '));
        setAlertSeverity('error');
      }

      return data; // devuelvo todo el objeto para quien lo necesite
    }

    // Si es respuesta única (no array)
    if (response.ok) {
      setAlertMessage(translate('create_center_success_message'));
      setAlertSeverity('success');
      return data;
    } else {
      // determino clave de traducción y mensaje
      const status = response.status;
      const key = getErrorKey(status);
      const serverMsg = data.mensaje;
      const text = (key === 'create_error1_message')
        ? serverMsg
        : translate(key);

      setAlertMessage(text);
      setAlertSeverity('error');

      throw new Error(serverMsg || translate('create_error2_message'));
    }
  } catch (error) {
    console.error('Error en CrearCentro:', error);
    setAlertMessage(translate('create_error3_message'));
    setAlertSeverity('error');
    throw error;
  }
}


// /get_users_historical_logs?start_date=2025-06-19&end_date=2025-07-2&type=all
export async function fetchLogs(servidor, startDate, endDate, type = 'all') {

    const params = new URLSearchParams({
        start_date: startDate,
        end_date: endDate,
        type
    });
    try {
        // Obtener la URL del servidor
        const SERVER_URL = await servidor;
        // Realizar la solicitud POST al servidor
        console.log('FULL URL',`${SERVER_URL}/get_users_historical_logs?${params.toString()}`)
        const response = await fetch(`${SERVER_URL}/get_users_historical_logs?${params.toString()}`, {
            method: 'GET',
            credentials: 'include',         // ← aquí también
            headers: {
                'Content-Type': 'application/json'
            },
        });
        if (response && response.ok) {
            console.log('Datos obtenidos con éxito!');
          }
        console.log('response',response)
        console.log('response',response)

        // Si la respuesta es exitosa, devolver los datos recibidos del servidor
        return await response.json();
    } catch (error) {
        // Capturar y manejar cualquier error que ocurra durante la solicitud
        console.error('Hubo un error al editar el centro:', error);
        throw error;
    }
}


// /<SERVICE>/consolidado_estados', methods=['GET']

// -- API consolidado_estados -- //


export async function fetchConsolidadoCenters(PAGE, servidor) {
  try {
      let SERVER_URL = await servidor;        
      // Si no se pudo obtener la URL del servidor, retornar null
      if (SERVER_URL === "Error en conexión") {
          console.error("No se pudo establecer una conexión con el servidor.");
          return {};
      }
      const endpoint = `/${PAGE}/consolidado_estados`;
      const fullUrl = `${SERVER_URL}${endpoint}`;
      const response = await fetch(fullUrl, {
          method: 'GET',
          credentials: 'include',         // ← aquí también
          headers: {
              'Content-Type': 'application/json',
          },
          keepalive: false
      });

      // console.log('respuesta servidor', response)

      if (!response.ok) {
          throw new Error('Error en la solicitud');
      }

      const result = await response.json();
      // console.log('Respuesta del servidor:', result);
      
      // Retornar el resultado
      return result;
  } catch (error) {
      console.error('Error:', error);
      return {};  // Retornar un objeto vacío en caso de error
  }
};





// -- API consolidado_servicios -- //
export async function fetchConsolidadoService( servidor) {
  console.log('fetchConsolidadoService_servidor',servidor)
    try {
        const SERVER_URL = await servidor;

        const endpoint = `/estado_servicio_ios`;
        const fullUrl = `${SERVER_URL}${endpoint}`;
        // console.log('respuesta fullUrl', fullUrl)
        const response = await fetch(fullUrl, {
            method: 'GET',
            credentials: 'include',      
            headers: {
                'Content-Type': 'application/json',
            },
            keepalive: false  // Asegura cerrar la conexión después de que se haya completado la solicitud
        });

        // console.log('respuesta servidor estado_servicio_2', response)

        if (!response.ok) {
            throw new Error('Error en la solicitud');
        }

        const result = await response.json();
        // console.log('Respuesta del servidor:', result);
        // console.log('respuesta servidor estado_servicio_2', result)
        
        // Retornar el resultado
        return result?.serviciosCentro || result?.servicios_centro || result;
    } catch (error) {
        console.error('Error:', error);
        return {};  // Retornar un objeto vacío en caso de error
    }
};
